import { Component, OnInit, AfterViewInit, Inject, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FlexmonsterPivot } from 'ng-flexmonster';
import * as Flexmonster from 'flexmonster';
import * as moment from 'moment';
import { PreviewBalanceConstants, PlayGroundAction } from "../../shared/constants/previewBalance.constants";
import { Report } from "../../shared/models/previewBalance/report.model";
import { PreviewScheduleService } from "../../services/preview-schedule.service";
import { ModalService } from "../../services/modal.service";
import { StaffPlaygroundAssignModalComponent } from "./staffPlaygroundAssignModal/staffPlaygroundAssignModal.component";
import { StaffPlaygroundEditRackModalComponent } from './staffPlaygroundEditRackModal/staffPlaygroundEditRackModal.component';
import { PlaygroundChangesComponent } from "./playgroundChangesPanel/playgroundChanges.component";
import { StaffPlaygroundActionVM, ChangesItem, RoomStaffByRack } from "../../shared/models/previewBalance/playground/changes.model";

@Component({
    selector: 'app-staff-playground',
    templateUrl: './staffPlayground.component.html',
    styleUrls: ['./staffPlayground.component.scss']
})
export class StaffPlaygroundComponent implements OnChanges, AfterViewInit {

    @Input() playground: any = [];
    @Input() playgroundReport: Report;
    @Input() licenseKey: string;
    @ViewChild('pivot', { static: false }) pivot: FlexmonsterPivot;
    @ViewChild(PlaygroundChangesComponent, { static: false }) playgroundChanges: PlaygroundChangesComponent;
    global: any = PreviewBalanceConstants.global;
    @Output() playgroundApplied: EventEmitter<any> = new EventEmitter();
    @Output() deleteOpenedDraft: EventEmitter<any> = new EventEmitter();

    constructor(
        private previewSchedule: PreviewScheduleService,
        private modalService: ModalService) { }

    ngAfterViewInit() {

        document['flexmonsterCellClick'] = (staff, room, isRackEdit?) => {

            let report = this.pivot.flexmonster.getReport() as Flexmonster.Report;

            let records = report.dataSource.data.filter(record => {
                return record['Staff'] === staff && record['Room'] === room;
            });

            let record = records[0];

            if (staff === '(Unassigned)') {
                this.OpenAssignModal(record);
            }
            else {
                if (isRackEdit) {
                    if (this.hasRoomRacks(records)) {
                        this.OpenEditModal(record);
                    }
                }
                else {
                    this.UnassignStaff(record);
                }

            }
        };

        this.playgroundChanges.load(this.playgroundReport.reportId);
        this.pivot.flexmonster.on('reportcomplete', () => {
            this.replayChanges(this.playgroundReport.playgroundChanges);
            this.pivot.flexmonster.off('reportcomplete');
        });

        this.pivot.flexmonster.on('exportstart', () => {
            this.pivot.flexmonster.customizeCell(null);
        });
        this.pivot.flexmonster.on('exportcomplete', () => {
            this.pivot.flexmonster.customizeCell(this.customizeCell);
        });
        
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.playgroundReport && !changes.playgroundReport.isFirstChange()) {

            this.playgroundChanges.load(this.playgroundReport.reportId);
            this.pivot.flexmonster.setReport(this.playground);
            this.pivot.flexmonster.on('reportcomplete', () => {
                this.replayChanges(this.playgroundReport.playgroundChanges);
                this.pivot.flexmonster.off('reportcomplete');
            });
        }
    }

    onPlaygroundApplied() {
        this.playgroundApplied.emit(this.playgroundReport.playgroundChanges);
    }

    public StaffPlaygroundAction = (request: StaffPlaygroundActionVM, changesItem?: ChangesItem) => {

        let currentReport = this.playgroundReport;

        this.previewSchedule.StaffPlaygroundAction(request).then((result) => {

            if (request.action === PlayGroundAction.RevertAll) {
                currentReport.playgroundChanges = [];
                this.pivot.flexmonster.setReport(this.playground);
            }
            else {
                this.updateReportChanges(currentReport, this.StaffPlaygroundActionChanges(request, changesItem, result.data.roomStaffByRacks));
            }

            currentReport.lastUpdatedDate = moment().format('MM/DD/YYYY');

            if (currentReport.reportId === this.playgroundReport.reportId) {
                this.replayChanges(this.playgroundReport.playgroundChanges);
                this.playgroundChanges.load(this.playgroundReport.reportId);
            }

            this.modalService.Success(result.data.message, { container: this.GetModalContainer() });
        });
    }

    private hasRoomRacks(records: any) {
        let hasRoomRack = records.filter(x => x['Rack'].length && x['Rack'] !== '(Room activities)' && x['Rack'] !== '(Staff activities)' && x['Rack'] !== '(QC Check activities)' && x['Rack'] !== '(Attendance)' && x['Rack'] !== 'Cage activities').length;

        return hasRoomRack;
    }

    private UnassignStaff(record) {
        
        let requestObject = new StaffPlaygroundActionVM();
        requestObject.reportId = this.playgroundReport.reportId;
        requestObject.staffId = record['Staff ID'];
        requestObject.staffName = record['Staff'];
        requestObject.facilityCode = record['Facility Code'];
        requestObject.roomNumber = record['Room'];
        requestObject.action = PlayGroundAction.UnassignFromRoom;

        this.StaffPlaygroundAction(requestObject);

    }

    private AssignStaff(record, staff) {

        let requestObject = new StaffPlaygroundActionVM();
        requestObject.reportId = this.playgroundReport.reportId;
        requestObject.staffId = staff.staffId;
        requestObject.staffName = staff.staffName;
        requestObject.facilityCode = record['Facility Code'];
        requestObject.roomNumber = record['Room'];
        requestObject.action = PlayGroundAction.AssignToRoom;
          
        this.StaffPlaygroundAction(requestObject);
    }

    private UpdateStaffLimitToRack(record, staff) {

        let requestObject = new StaffPlaygroundActionVM();
        requestObject.reportId = this.playgroundReport.reportId;
        requestObject.staffId = staff.staffId;
        requestObject.staffName = staff.staffName;
        requestObject.selectedRackIdsArray = staff.selectedRackIdsArray;
        requestObject.facilityCode = record['Facility Code'];
        requestObject.roomNumber = record['Room'];
        requestObject.action = PlayGroundAction.AddStaffLimitToRack;
        requestObject.newLimitToRack = staff.selectedRackIdsArray.join(';');

        this.StaffPlaygroundAction(requestObject);
    }

    private OpenAssignModal(record) {

        let request = {
            reportId: this.playgroundReport.reportId,
            unitId: record['Unit ID'],
            FacilityCode: record['Facility Code'],
            RoomNumber: record['Room']
        };

        let loading = this.modalService.Loading({ container: this.GetModalContainer() });

        this.previewSchedule.StaffPlaygroundDialog(request).then((result) => {
            loading.dismiss();
            if (result.success) {
                let modal = this.modalService.OpenModal(StaffPlaygroundAssignModalComponent, { container: this.GetModalContainer() });
                modal.componentInstance.data = result.data;
                modal.result.then((staff) => {
                    if (staff) {
                        this.AssignStaff(record, staff);
                    }
                });
            }
        });

    }

    private OpenEditModal(record) {

        let request = {
            reportId: this.playgroundReport.reportId,
            unitId: record['Unit ID'],
            FacilityCode: record['Facility Code'],
            RoomNumber: record['Room'],
            StaffId: record['Staff ID']
        };

        let loading = this.modalService.Loading({ container: this.GetModalContainer() });

        this.previewSchedule.AssignToRackDialog(request).then((result) => {
            loading.dismiss();
            if (result.success) {
                let modal = this.modalService.OpenModal(StaffPlaygroundEditRackModalComponent, { container: this.GetModalContainer() });
                modal.componentInstance.data = result.data;
                modal.result.then((staff) => {
                    if (staff) {
                        this.UpdateStaffLimitToRack(record, staff);
                    }
                });
            }
        });
    }

    public deleteDraft() {
        this.deleteOpenedDraft.emit([this.playgroundReport]);
    }
    
    customizeCell = (cell, data) => {
        if (data.columnIndex === 0 && data.level === 1) {
            if (data.label !== '(Staff activities)' && data.label !== '(Other activities)' && data.label !== '(Attendance)' && data.label.indexOf('(QC Check)') === -1) {
                if (data.rows[0].caption === '(Unassigned)') {
                    cell.text += '<button class="btn ntm-button ntm-primary-button pull-right" style="height: 22px; font-size: 12px;font-weight: bold;pointer-events: all; padding: 0px 14px;margin-top: -3px;" onclick="flexmonsterCellClick(\'' + data.rows[0].caption + '\',\'' + data.rows[1].caption + '\')"> Assign </button>';
                }
                else {
                    cell.text += '<button class="btn ntm-button ntm-primary-button pull-right" style="height: 22px; font-size: 12px;font-weight: bold;pointer-events: all; padding: 0px 14px;margin-top: -3px;" onclick="flexmonsterCellClick(\'' + data.rows[0].caption + '\',\'' + data.rows[1].caption + '\')"> Un-assign </button>';
                    cell.text += '<button class="btn ntm-button ntm-primary-button rack-btn pull-right" style="height: 22px; font-size: 12px;font-weight: bold;pointer-events: all; padding: 0px 14px;margin-top: -3px; margin-right: 5px;" onclick="flexmonsterCellClick(\'' + data.rows[0].caption + '\',\'' + data.rows[1].caption + '\', true)"> Racks </button>';
                    cell.addClass(this.getCellClass(data.rows[0].caption, data.rows[1].caption));
                }
            }
        }
    };

    public customizeToolbar(toolbar) {

        let tabs = toolbar.getTabs();
        let exportTab = tabs.find(tab => tab.id === 'fm-tab-export');
        let fullscreenTab = tabs.find(tab => tab.id === 'fm-tab-fullscreen');

        exportTab.rightGroup = true;
        toolbar.getTabs = () => {
            return [
                exportTab,
                { divider: true, rightGroup: true },
                fullscreenTab
            ];
        };
    }

    private getCellClass(staff: string, roomNumber: string) {
        if(staff && roomNumber){
            let report = this.pivot.flexmonster.getReport() as Flexmonster.Report;

            let records = report.dataSource.data.filter(record => {
                return record['Staff'] === staff && record['Room'] === roomNumber;
            });
            
            if (!this.hasRoomRacks(records)) {
                return 'hide-rack-btn';
            }
        }

        return '';
    }

    private GetModalContainer() {
        return '.fm-ng-wrapper';
    }

    public replayChanges(data) {

        if (data && data.length > 0) {
            //@ts-ignore
            this.pivot.flexmonster.updateData({ data }, { partial: true });
        }
    }

    private updateReportChanges(currentReport, data) {

        let keys = [];

        data.forEach(function (record) {

            let isPresent = keys.filter(function (key) {
                return key['Facility Code'] === record['Facility Code'] && key['Room'] === record['Room'];
            });

            if (isPresent.length === 0) {
                keys.push(record);
            }
        });

        keys.forEach((key) => {
            currentReport.playgroundChanges = currentReport.playgroundChanges.filter(record => {
                return !(record['Facility Code'] === key['Facility Code'] && record['Room'] === key['Room']);
            });
        });

        currentReport.playgroundChanges = currentReport.playgroundChanges.concat(data);
    }


    private StaffPlaygroundActionChanges(request: StaffPlaygroundActionVM, changesItem: ChangesItem, roomStaffByRacks: RoomStaffByRack[]) {


        let data = (this.pivot.flexmonster.getReport() as Flexmonster.Report).dataSource.data;

        let roomActivitiesData = data.filter(record => record['Facility Code'] === request.facilityCode && record['Room'] === request.roomNumber).map(record => Object.assign({}, record));

        let roomActivities = [];

        roomActivitiesData.reverse().forEach(record => {

            let isPresent = roomActivities.filter(function (roomActivity) {
                return record['PreviewItemId'] === roomActivity['PreviewItemId'];
            });

            if (isPresent.length === 0) {
                roomActivities.push(record);
            }
        });

        roomStaffByRacks.forEach((roomStaffByRack, index) => {
            roomStaffByRack.scheduleDates = data.filter(record => record['Activity'] === '(Attendance)' && record['Staff ID'] == roomStaffByRack.staffId).map(record => record['Day']);
        });

        roomActivities.forEach(record => {
            let staffAttendance = roomStaffByRacks.find(item => item.scheduleDates.indexOf(record['Day']) !== -1 && ((!record["CcrackID"] && !item.ccrackId) || (record["CcrackID"] == item.ccrackId)));

            if (staffAttendance) {
                record['Staff ID'] = staffAttendance.staffId;
                record['Staff'] = staffAttendance.staffName;
                record['Assignment Priority'] = staffAttendance.assignmentPriority;
            }
            else {
                record['Staff ID'] = "";
                record['Staff'] = "(Unassigned)";
                record['Assignment Priority'] = "";
            }
        });

        return roomActivities;
    }
    
}

